import CustomContentPanel from './CustomContentPanel';

export default CustomContentPanel;
